var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{class:_vm.classType,attrs:{"type":_vm.buttonType,"disabled":_vm.disabled || _vm.inactive},on:{"click":_vm.startCountdown}},[_vm._v(" "+_vm._s(_vm.displayText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }